import { themeChange } from "theme-change";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Bars3Icon from "@heroicons/react/24/outline/Bars3Icon";
import MoonIcon from "@heroicons/react/24/outline/MoonIcon";
import SunIcon from "@heroicons/react/24/outline/SunIcon";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";

function Header() {
  const location = useLocation();
  const admin = JSON.parse(localStorage.getItem("adminData"));
  const { pageTitle } = useSelector((state) => state.header);
  const [currentTheme, setCurrentTheme] = useState(
    localStorage.getItem("theme"),
  );
  
  // Check if we're on a user view route (not /admin/*)
  const isUserView = !location.pathname.startsWith("/admin");

  useEffect(() => {
    themeChange(false);
    // 👆 false parameter is required for react project
    if (currentTheme === null) {
      // Default to light mode
      setCurrentTheme("light");
      localStorage.setItem("theme", "light");
    }
  }, [currentTheme]);

  function logoutUser() {
    axios.post("/api/admin/logout");
    localStorage.clear();
    window.location.href = "/";
  }

  return (
    // navbar fixed  flex-none justify-between bg-base-300  z-10 shadow-md

    <>
      <div className="navbar sticky top-0 bg-base-100  z-10 shadow-md ">
        {/* Menu toggle for mobile view or small screen */}
        <div className="flex-1">
          <label
            htmlFor="left-sidebar-drawer"
            className="btn btn-primary drawer-button lg:hidden"
          >
            <Bars3Icon className="h-5 inline-block w-5" />
          </label>
          <h1 className="text-2xl font-semibold ml-2">{pageTitle}</h1>
        </div>

        <div className="flex-none ">
          {/* Light and dark theme selection toggle **/}
          <label className="swap ">
            <input type="checkbox" />
            <SunIcon
              data-set-theme="light"
              data-act-class="ACTIVECLASS"
              className={
                "fill-current w-6 h-6 " +
                (currentTheme === "dark" ? "swap-on" : "swap-off")
              }
            />
            <MoonIcon
              data-set-theme="dark"
              data-act-class="ACTIVECLASS"
              className={
                "fill-current w-6 h-6 " +
                (currentTheme === "light" ? "swap-on" : "swap-off")
              }
            />
          </label>

          {admin ? (
            <>
              {/* User View and Logout buttons */}
              <Link 
                to={admin && isUserView ? "/admin/messages" : "/"} 
                className="btn btn-ghost ml-4"
              >
                {admin && isUserView ? "Admin View" : "User View"}
              </Link>
              <button className="btn btn-ghost ml-2" onClick={logoutUser}>
                Logout
              </button>
            </>
          ) : (
            <>
              <button
                className="btn ml-4"
                onClick={() => (window.location.href = "/login")}
              >
                Admin
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default Header;
